import {Tag} from 'folder-items/FileConstants';
import {addPrimersToField as addPrimersToFieldDAO} from 'molbio/dao/PrimerDAO';
import notifications from 'notifications';
import * as net from 'util/Net';

export async function addPrimersToField(
  sequenceId: string,
  data: {schemaFieldId: string; oligoIds: Array<string>}
): Promise<Array<Tag> | null> {
  try {
    const response = await addPrimersToFieldDAO(sequenceId, data);
    notifications.success('Added oligos to field');
    return response.tags;
  } catch (e) {
    if (net.isServerRequestError(e)) {
      notifications.stickyNotifyForFriendlyError(e, 'add-oligos-to-schema-field');
      return null;
    } else {
      throw e;
    }
  }
}
